import { AufnahmePunktDocument, BodenvegetationZeile, SchichtAnteile } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";

const SCHICHTEN: readonly ('b1'|'b2'|'str'|'kr1'|'kr2'|'m')[] = ['b1', 'b2', 'str', 'kr1', 'kr2', 'm'];

function sumHaeufigkeit(zeilen: BodenvegetationZeile[], schicht: 'b1'|'b2'|'str'|'kr1'|'kr2'|'m'): number {
	return zeilen
		.filter(bv => bv.schicht === schicht)
		.reduce((sum, bv) => {
			const anteil = parseFloat(bv.haeufigkeit);
			return sum + (!isNaN(anteil) ? anteil : 0);
		}, 0);
}

export function schichtAnteilEval(schicht: 'b1'|'b2'|'str'|'kr1'|'kr2'|'m'): EvalFunc {
	return (bp: any, _i?: number, _key?: string) => {
		const zeilen = (bp as AufnahmePunktDocument)?.bodenvegetation?.aufnahme?.vegetationen;
		if (!Array.isArray(zeilen)) return undefined;
		const schichtZeilen = zeilen.filter(bv => bv.schicht === schicht);
		if (schichtZeilen.length === 0) return undefined;
		return sumHaeufigkeit(zeilen, schicht);
	};
}

/**
 * Berechnet aus den Vegetationszeilen die Schichtanteil-Summen pro Schicht und
 * schreibt sie in `bodenvegetation.aufnahme.schichtAnteile`. Schichten ohne
 * Eintraege werden weggelassen (undefined-Slots, kein 0-Wert).
 *
 * Wird aufgerufen, sobald sich Vegetationszeilen aendern: im Detail-Editor
 * (Add/Remove/Edit) und im Batch-Editor (nachdem leere Schichten gefuellt wurden).
 */
export function updateSchichtAnteile(doc: { bodenvegetation?: { aufnahme?: { vegetationen?: BodenvegetationZeile[]; schichtAnteile?: SchichtAnteile } } }): void {
	const aufnahme = doc?.bodenvegetation?.aufnahme;
	const zeilen = aufnahme?.vegetationen;
	if (!aufnahme || !Array.isArray(zeilen)) return;
	const anteile: SchichtAnteile = {};
	for (const sch of SCHICHTEN) {
		const sum = sumHaeufigkeit(zeilen, sch);
		if (sum > 0) anteile[sch] = sum;
	}
	aufnahme.schichtAnteile = anteile;
}
